// appInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights = null;

export function initAppInsights() {
  if (typeof window !== 'undefined' && !appInsights) {  // Ensure it's client-side
    console.log('Initializing Application Insights');
    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: process.env.NEXT_PUBLIC_APP_INSIGHTS_KEY
      }
    });
    appInsights.loadAppInsights();
  }
}

export function trackPageView(name) {
  appInsights?.trackPageView({ name });
}

export function trackEvent(name, properties) {
  appInsights?.trackEvent({ name, properties });
}

export function trackException(error) {
  appInsights?.trackException({ exception: error });
}

const ai = appInsights

export default ai;
